/* cart-license.js — Default ON, user can deselect to remove (no reloads, upsells untouched) */
(function () {
  const TOGGLE_SEL  = '[data-license-toggle]';
  const OPTOUT_KEY  = 'cineify_license_opt_out_v2';   // new key so prior tests don’t block
  const ALLOW_IN_EDITOR = true;                        // set false if you don’t want auto-add in editor

  // --- Shopify ajax helpers ---
  const getCart     = () => fetch('/cart.js').then(r => r.json());
  const getProduct  = (h) => fetch(`/products/${h}.js`).then(r => { if(!r.ok) throw new Error('Missing product: '+h); return r.json(); });
  const addVariant  = (id) => fetch('/cart/add.js',    { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id:Number(id), quantity:1 }) });
  const changeByKey = (key, qty) => fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id:key, quantity:qty }) });

  const findItem = (cart, { handle, variantId }) =>
    cart.items.find(i => (handle && i.handle === handle) || (variantId && String(i.variant_id) === String(variantId)));

  // Get handle even if toggle isn't in DOM yet
  function getHandle() {
    const el = document.querySelector(TOGGLE_SEL);
    return (el && el.getAttribute('data-license-handle')) || (window.CINEIFY_LICENSE_HANDLE) || 'commercial-license';
  }

  function formatMoney(cents){
    const fmt = (window.Shopify && (Shopify.money_with_currency_format || Shopify.money_format)) || '£{{amount}}';
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmt);
    return '£' + (cents/100).toFixed(2);
  }

  async function updateTotal(){
    try {
      const cart = await getCart();
      document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = formatMoney(cart.total_price));
    } catch(_) {}
  }

  async function syncToggle(){
    const input = document.querySelector(TOGGLE_SEL);
    if (!input) return;
    const handle = getHandle();
    try {
      const cart = await getCart();
      input.checked = !!findItem(cart, { handle });
    } catch(_) {}
  }

  // Auto-add once on load if default=on, not opted out, not already in cart
  async function ensureDefaultAdded(){
    const input = document.querySelector(TOGGLE_SEL);
    const inEditor = !!(window.Shopify && Shopify.designMode);
    if (inEditor && !ALLOW_IN_EDITOR) return;

    // If toggle exists, only auto-add when merchant set default=on
    const defaultAttr = input ? (input.getAttribute('data-default') || '') : 'on';
    const defaultOn = defaultAttr.toLowerCase() === 'on';
    if (!defaultOn) return;

    if (localStorage.getItem(OPTOUT_KEY) === '1') return; // respect prior opt-out

    const handle = getHandle();
    try {
      const product   = await getProduct(handle);
      const variantId = product.variants[0].id;
      const cart      = await getCart();
      const current   = findItem(cart, { handle, variantId });

      if (!current) {
        await addVariant(variantId);
        if (input) input.checked = true;
        await updateTotal();
      }
    } catch(_) {}
  }

  async function onChange(e){
    const input = e.target.closest(TOGGLE_SEL);
    if (!input) return;

    const handle = getHandle();
    input.disabled = true;

    try {
      const product   = await getProduct(handle);
      const variantId = product.variants[0].id;
      const cart      = await getCart();
      const current   = findItem(cart, { handle, variantId });

      if (input.checked) {
        if (!current) await addVariant(variantId);
        localStorage.removeItem(OPTOUT_KEY);
      } else {
        if (current) await changeByKey(current.key, 0);
        localStorage.setItem(OPTOUT_KEY, '1');
      }

      await updateTotal();
      await syncToggle();
    } catch(_) {
      await syncToggle();
    } finally {
      input.disabled = false;
    }
  }

  // If drawer HTML mounts later, watch for it and run once
  const once = { ran:false };
  const obs = new MutationObserver(() => {
    if (!once.ran && document.querySelector(TOGGLE_SEL)) {
      once.ran = true;
      ensureDefaultAdded().then(syncToggle).then(updateTotal);
      obs.disconnect();
    }
  });

  document.addEventListener('change', onChange);

  document.addEventListener('DOMContentLoaded', async () => {
    // If toggle already present, do it now
    if (document.querySelector(TOGGLE_SEL)) {
      await ensureDefaultAdded();
      await syncToggle();
      await updateTotal();
    } else {
      // Otherwise wait for the drawer to appear
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  });

  // Safety: keep total/toggle in sync if theme triggers these
  document.addEventListener('cart:refresh:after', async () => { await syncToggle(); await updateTotal(); });
  document.addEventListener('shopify:section:load', async () => { await syncToggle(); await updateTotal(); });
})();
